import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import AssessmentOffers from "@/components/AssessmentOffers";
import GrowthSystem from "@/components/GrowthSystem";
import ServicePackages from "@/components/ServicePackages";
import DigitalProducts from "@/components/DigitalProducts";
import Consulting from "@/components/Consulting";
import WhoWeServe from "@/components/WhoWeServe";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import Guarantee from "@/components/Guarantee";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import QuizBanner from "@/components/QuizBanner";
import StickyCta from "@/components/StickyCta";
import { scrollToId } from "@/lib/scroll";
import { track } from "@/lib/track";

export default function OfferPage() {
  const location = useLocation();

  useEffect(() => {
    track("view_offer");
  }, []);

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash.slice(1)), 350);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <div data-testid="offer-page" className="relative bg-obsidian min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <AssessmentOffers />
        <QuizBanner />
        <GrowthSystem />
        <ServicePackages />
        <DigitalProducts />
        <Consulting />
        <WhoWeServe />
        <WhyUs />
        <Process />
        <Guarantee />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}
